<template>
  <div>
    <ul class="product_ul">
      <li
        v-for="(item, index) in serviceList"
        :key="index"
        class="product_li li"
        @click="getproductName(item.name, index)"
        :class="{
          active: activeIndex === index,
          activeMobile: activeIndex === index && item.name === 'Mobile Malware Detection',
          activeUrl: activeIndex === index && item.name === 'URL Filtering',
          activeApp: activeIndex === index && item.name === 'App Insights'
        }"
      >
        <div class="logo" v-if="item.name !== 'No Subscription'">
          <i
            :class="{
              'icon-mobile-service': item.name === 'Mobile Malware Detection',
              'icon-url-service': item.name === 'URL Filtering',
              'icon-app-service': item.name === 'App Insights',
              'icon-wifi-service': item.name === 'WiFi Security'
            }"
          ></i>
        </div>
        <!-- product name -->
        <h3 class="title">{{ lang === 'en' ? item.name : formatNames(item.name) || item.name }}</h3>
        <!-- Monthly API Quota -->
        <div class="total" v-if="item.name !== 'No Subscription'">
          <div class="left">
            {{ $t('dashboard.quotaApi') }}
          </div>
          <div :class="item.quota < 100000000000 ? 'right' : 'scale_right'">
            {{ formatter(item.quota) }}
          </div>
        </div>
        <!-- Consumed API Call -->
        <div class="total" v-if="item.name !== 'No Subscription'">
          <div class="left">
            {{ $t('dashboard.monthApi') }}
          </div>
          <div
            :class="{
              right:
                (item.name === 'Mobile Malware Detection' &&
                  item.monthly < 100000000000 &&
                  monthlyAPICalls < 100000000000) ||
                item.name !== 'Mobile Malware Detection',
              scale_right:
                item.name === 'Mobile Malware Detection' &&
                (item.monthly >= 100000000000 || monthlyAPICalls >= 100000000000),
              green: item.name === 'Mobile Malware Detection' && monthlyAPICalls <= item.quota,
              red: item.name === 'Mobile Malware Detection' && monthlyAPICalls > item.quota
            }"
          >
            {{
              formatter(
                item.name === 'Mobile Malware Detection' ? monthlyAPICalls.toString() : item.monthly
              )
            }}
          </div>
        </div>
        <!-- Malware API Calls -->
        <div class="total" v-if="item.name !== 'No Subscription'">
          <div class="left">
            {{ $t('dashboard.malwareApi') }}
          </div>
          <div :class="item.malicious < 100000000000 ? 'right' : 'scale_right'" :load="log(Object.values(apiList).reduce((acc, cur) => acc + cur.malware_query_count, 0))">
            {{ formatter(Object.values(apiList).reduce((acc, cur) => acc + cur.malware_query_count, 0)) || 0 }}
          </div>
        </div>
        <!-- Billing Cycle Start -->
        <div class="total" v-if="item.name !== 'No Subscription'">
          <div class="left">
            {{ $t('dashboard.billingCycleStartDate') }}
          </div>
          <div class="date">
            {{ billingCycle.start }}
          </div>
        </div>
        <!-- Billing Cycle End -->
        <div class="total" v-if="item.name !== 'No Subscription'">
          <div class="left">
            {{ $t('dashboard.billingCycleEndDate') }}
          </div>
          <div class="date">
            {{ billingCycle.end }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { common } from '@/views/public/common'
  export default {
    name: 'UserService',
    props: {
      serviceList: {
        type: Array,
        default: []
      },
      name: {
        type: String,
        default: ''
      },
      monthlyAPICalls: {
        type: Number,
        default: 0
      },
      billingCycle: {
        type: Object,
        default: { start: '', end: '' }
      },
      apiList: {
        type: Object,
        require: true
      }
    },
    data() {
      return {
        activeIndex: 0
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      getproductName(name, index) {
        this.$emit('changeProductName', name)
        this.activeIndex = index
      },
      formatter: common.formatter,
      formatNames: common.formatNames,
      // debug
      log(item) {
        console.log(item)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .product_ul {
    @include flex-wrap;
  }

  .product_li {
    min-width: 210px;
    /* height: 230px; */
    height: 100%;
    background: $white;
    margin: 0 32px 32px 0;
    @include border-radius(6px);
    padding: 20px 23px 0 23px;
    box-sizing: border-box;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      cursor: pointer;
    }
    .logo {
      width: 40px;
      height: 40px;
      margin: 0 auto;
      font-size: 40px;
    }
    .title {
      text-align: center;
      height: 33px;
      line-height: 33px;
      margin-bottom: 16px;
      font-family: NexaBold;
      font-size: 14px;
    }
    .total {
      margin-bottom: 17px;
      @include flex-space-center;
      height: 12px;
      .left {
        text-align: left;
        margin-right: 12px;
        color: rgba(43, 62, 81, 0.7);
        font-size: 12px;
        line-height: 12px;
      }
      .right {
        text-align: right;
        font-size: 16px;
        color: #2b3e51;
        font-family: Lato-Bold;
        font-weight: bold;
      }
      .green {
        color: hsl(156, 50%, 50%);
      }
      .red {
        color: hsl(0, 50%, 50%);
      }
      .date {
        text-align: right;
        font-size: 14px;
        color: #2b3e51;
        font-family: Lato-Bold;
        font-weight: bold;
      }
    }
    .scale_right {
      font-size: 12px;
      text-align: left;
      color: #333;
    }
  }
  .active {
    box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.1);
  }
  .activeMobile {
    border: 0.7px solid #ffb900;
  }
  .activeUrl {
    border: 0.7px solid #39c6fa;
  }
  .activeApp {
    border: 0.7px solid #3cdcd2;
  }
  @media screen and (max-width: 450px) {
    .product_li {
      width: 100%;
      height: auto;
      min-height: 230px;
      margin-right: 0;
      .title {
        font-size: 16px;
        min-height: 33px;
        height: auto;
        line-height: 20px;
        padding-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/user-service.vue